/***
 * @file:æ´æ°dom class
 * @author: linkun.he
 * @Date: 2019-06-03 10:11:13
 */
import { Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class UpdateEleClassService {
  private renderer: Renderer2;
  private classMap = {};

  constructor(rendererFactory: RendererFactory2) {
    this.renderer = rendererFactory.createRenderer(null, null);
  }

  // æ´æ°
  updateEleClass(ele: HTMLElement, classMap: object): void {
    this.removeClass(ele, this.classMap, this.renderer);
    this.classMap = { ...classMap };
    this.addClass(ele, this.classMap, this.renderer);
  }

  // ç§»é¤class
  private removeClass(ele: HTMLElement, classMap: object, renderer: Renderer2): void {
    for (const i in classMap) {
      if (classMap.hasOwnProperty(i)) {
        renderer.removeClass(ele, i);
      }
    }
  }

  // æ·»å class
  private addClass(ele: HTMLElement, classMap: object, renderer: Renderer2): void {
    for (const i in classMap) {
      if (classMap.hasOwnProperty(i)) {
        if (classMap[i]) {
          renderer.addClass(ele, i);
        }
      }
    }
  }
}
